export const EMPLOYMENT_PERIOD = {
    FIXED_TERM: 1,
    INDEFINITE: 2,
} as const;

export type TEmploymentPeriod = (typeof EMPLOYMENT_PERIOD)[keyof typeof EMPLOYMENT_PERIOD];

export const EMPLOYMENT_PERIOD_LABELS: Record<TEmploymentPeriod, string> = {
    [EMPLOYMENT_PERIOD.INDEFINITE]: "無期",
    [EMPLOYMENT_PERIOD.FIXED_TERM]: "有期",
};

export const EMPLOYMENT_PERIOD_OPTIONS = [
    { value: EMPLOYMENT_PERIOD.INDEFINITE, label: EMPLOYMENT_PERIOD_LABELS[EMPLOYMENT_PERIOD.INDEFINITE] },
    { value: EMPLOYMENT_PERIOD.FIXED_TERM, label: EMPLOYMENT_PERIOD_LABELS[EMPLOYMENT_PERIOD.FIXED_TERM] },
];

export const getEmploymentPeriodLabel = (value: number | null | undefined): string =>
    EMPLOYMENT_PERIOD_LABELS[value as TEmploymentPeriod] ?? EMPLOYMENT_PERIOD_LABELS[EMPLOYMENT_PERIOD.FIXED_TERM];
